import { render, staticRenderFns } from "./ProgressBarWithTextEl.vue?vue&type=template&id=5c89099a&scoped=true&"
import script from "./ProgressBarWithTextEl.vue?vue&type=script&lang=ts&"
export * from "./ProgressBarWithTextEl.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBarWithTextEl.vue?vue&type=style&index=0&id=5c89099a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c89099a",
  null
  
)

export default component.exports